<p-card header="Ihr Warenkorb">
  <div class="mb-4" *ngIf="orderService.salescode$ | async as salescode">
    <p-tag [value]="'Vertriebskürzel: ' + salescode" severity="info"></p-tag>
  </div>
  <div *ngIf="isAvailable$ | async">
    <div class="text-lg font-semibold border-bottom-2 border-cyan-500 mb-2">Adressdaten</div>
    {{ addressesService.streetName$ | async }}
    {{ addressesService.streetNumber$ | async }}<br />
    {{ addressesService.postalCode$ | async }}
    {{ addressesService.city$ | async }}<br />
  </div>
  <span *ngIf="productsService.baseProduct$ | async as baseProduct">
    <div class="text-lg font-semibold border-bottom-2 border-cyan-500 mb-2 mt-4">{{ baseProduct.name }}</div>
    Bis zu {{ baseProduct.marketingInformation.speedDown }} Mbit/s Download und bis zu {{ baseProduct.marketingInformation.speedUp }} Mbit/s Upload<br />
    <span *ngFor="let includedProduct of includedProducts()">
      {{ includedProduct.name }}<br />
    </span>
    <div class="text-lg font-semibold border-bottom-2 border-cyan-500 mb-2 mt-4">Monatliche Kosten</div>
    <div class="flex flex-row" *ngFor="let pos of monthlyPositions()">
      <div class="flex">{{ pos.name }}</div>
      <div class="flex flex-grow-1 justify-content-end">{{ pos.sum | currency:"EUR" }}</div>
    </div>  
    <div class="flex flex-row font-semibold">
      <div class="flex">{{ sumLabel }}</div>
      <div class="flex flex-grow-1 justify-content-end">{{ productsService.totalMonthlyDiscountedFee$ | async | currency:"EUR" }}</div>
    </div>
    <div class="flex flex-row" *ngFor="let monthlyDiscount of monthlyDiscounts()">
      <div class="flex">ab dem {{ monthlyDiscount.monthAfter }}. Monat</div>
      <div class="flex flex-grow-1 justify-content-end font-semibold">{{ monthlyDiscount.sumAfterDiscounts| currency:"EUR" }}</div>
    </div>
    <div class="text-lg font-semibold border-bottom-2 border-cyan-500 mb-2 mt-4">Einmalige Kosten</div>
    <div class="flex flex-row" *ngFor="let pos of startFeeyPositions()">
      <div class="flex">{{ pos.name }}</div>
      <div class="flex flex-grow-1 justify-content-end">{{ pos.sum | currency:"EUR" }}</div>
    </div>  
    <div class="flex flex-row font-semibold">
      <div class="flex">{{ sumLabel }}</div>
      <div class="flex flex-grow-1 justify-content-end">{{ productsService.totalStartFee$ | async | currency:"EUR" }}</div>
    </div>
    <div *ngIf="hasCoupon()">
      <div class="text-lg font-semibold border-bottom-2 border-cyan-500 mb-2 mt-4">Coupon</div>
      <form [formGroup]="form" class="formgrid grid" *ngIf="!couponProduct()">
        <div class="field col-12">
          <label for="couponCodeInput">Coupon Code</label>
          <input type="text" pInputText id="couponCodeInput" formControlName="couponCode" class="w-full" />
        </div>
        <div class="field col-12">
          <button type="button" pButton label="Coupon einlösen" class="w-full" [disabled]="form.controls.couponCode.invalid" (click)="submitCoupon()"></button>
        </div>
      </form>
      <div *ngIf="couponProduct()">
        <i class="fa fa-solid fa-check text-green-500"></i>
        Coupon "{{ couponProduct()!.name }}" eingelöst
      </div>
    </div>
  </span>
</p-card>
